import CageAllGraphsContainer from './CageAllGraphsContainer';

export default function CageAllGraphsProviderContainer() {
    return <CageAllGraphsContainer />;
}
